export default __webpack_public_path__ + "static/post_2-d79b10665790f67c741dd44889d5a31b.png";